import { BlockNoteEditor } from '@blocknote/core';
import { TextBlockSchema } from '../schema';

export default function getLinkUrlAtSelection(
  editor: BlockNoteEditor<TextBlockSchema>,
) {
  const direct = editor.getSelectedLinkUrl();
  if (typeof direct === 'string' && direct !== '') {
    return direct;
  }
  const linkMark = editor.pmSchema.marks['link'];
  if (!linkMark) {
    return '';
  }
  const linkTypeName = linkMark.name;
  const { doc, selection } = editor.prosemirrorState;
  const { $from, $to, empty } = selection;

  const hrefAtFrom = readLinkHrefFromMarks($from.marks(), linkTypeName);
  if (hrefAtFrom) {
    return hrefAtFrom;
  }
  const hrefAtTo = readLinkHrefFromMarks($to.marks(), linkTypeName);
  if (hrefAtTo) {
    return hrefAtTo;
  }

  if (!empty) {
    let found: string | undefined;
    doc.nodesBetween($from.pos, $to.pos, (node) => {
      if (found) {
        return false;
      }
      if (node.isText) {
        found = readLinkHrefFromMarks(node.marks, linkTypeName);
      }
      return true;
    });
    return found ?? '';
  }

  const pos = $from.pos;
  const docEnd = doc.content.size;
  const probePositions: Array<number> = [];
  if (pos > 0) {
    probePositions.push(pos - 1);
  }
  probePositions.push(pos);
  if (pos < docEnd) {
    probePositions.push(pos + 1);
  }
  for (const p of probePositions) {
    if (p < 0 || p > docEnd) {
      continue;
    }
    try {
      const href = readLinkHrefFromMarks(doc.resolve(p).marks(), linkTypeName);
      if (href) {
        return href;
      }
    } catch {
      // ignore invalid resolve
    }
  }
  return '';
}

function readLinkHrefFromMarks(
  marks: ReadonlyArray<{
    type: { name: string };
    attrs: Record<string, unknown>;
  }>,
  linkTypeName: string,
) {
  for (const m of marks) {
    if (m.type.name !== linkTypeName) {
      continue;
    }
    const href = m.attrs['href'];
    if (typeof href === 'string' && href !== '') {
      return href;
    }
  }
  return undefined;
}
